import { checkCopyErrors } from './plugins/checkCopyErrors'
import { Problem } from './types/Problem'
import { DataFlow } from 'models/DataFlow'

export const runGroupsLint = (flows: DataFlow[]): Problem[] => {
  return [...checkCopyErrors(flows)]
}
